import { render, staticRenderFns } from "./UnitOverview.vue?vue&type=template&id=4ad9c192&scoped=true&"
import script from "./UnitOverview.vue?vue&type=script&lang=js&"
export * from "./UnitOverview.vue?vue&type=script&lang=js&"
import style0 from "./UnitOverview.vue?vue&type=style&index=0&id=4ad9c192&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad9c192",
  null
  
)

component.options.__file = "UnitOverview.vue"
export default component.exports